module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "episode-modal-title"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/images/website/zappelin-logo.png'),
      "alt": "Zappelin logo"
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "episode-modal-title"
    }
  }, [_vm._v("De Boterhamshow")])]), _vm._v(" "), _c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Sluiten"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "aria-hidden": "true",
      "height": "24px",
      "id": "Layer_1",
      "version": "1.1",
      "viewBox": "0 0 512 512",
      "width": "24px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "role": "button",
      "aria-label": "Vorige aflevering"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "role": "button",
      "aria-label": "Volgende aflevering"
    }
  })]), _vm._v(" "), (_vm.lastFiveEpisodes) ? _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.lastFiveEpisodes), function(episode, index) {
    return _c('swiper-slide', {
      key: index
    }, [(episode.episodes[0]) ? _c('div', {
      staticClass: "episode"
    }, [_c('h2', [_vm._v(_vm._s(episode.episodes[0].title) + " " + _vm._s(_vm.dayName(episode.date)))]), _vm._v(" "), _c('div', {
      staticClass: "episode-content episode-content--box-shadow"
    }, [_c('div', {
      staticClass: "watch-episode"
    }, [_c('div', {
      staticClass: "iframe-wrapper"
    }, [_c('iframe', {
      staticClass: "iframe",
      attrs: {
        "src": ("https://player.ntr.nl/index.php?prid=" + (episode.episodes[0].prid) + "&showTitlebar=false"),
        "title": ("Videospeler " + (episode.episodes[0].title)),
        "aria-label": ("Videospeler " + (episode.episodes[0].title)),
        "align": "top",
        "frameborder": "0",
        "marginheight": "0",
        "marginwidth": "0",
        "scrolling": "no",
        "allow": "encrypted-media; geolocation; autoplay; fullscreen"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "play-episode"
    }, [_c('router-link', {
      attrs: {
        "to": ("/afleveringen/" + (_vm.stripEpisodeNumber(episode.episodes[0].name)))
      }
    }, [_c('img', {
      staticClass: "thumnbail",
      attrs: {
        "src": require('@/assets/images/website/interactive-img' + (index + 1) + '.jpg'),
        "alt": ("Thumbnail aflevering " + (_vm.stripEpisodeNumber(episode.episodes[0].name)))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "play-icon"
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 67.36 67.36"
      }
    }, [_c('g', {
      attrs: {
        "data-name": "Layer 2"
      }
    }, [_c('rect', {
      attrs: {
        "width": "67.36",
        "height": "67.36",
        "rx": "6.52",
        "ry": "6.52",
        "fill": "#7ebedd"
      }
    }), _c('path', {
      attrs: {
        "d": "M46.45 19.43H21.24a3.06 3.06 0 0 0-3.06 3.05v25.21a3.07 3.07 0 0 0 3.06 3.06h25.21a3.06 3.06 0 0 0 3-3.06V22.48a3.06 3.06 0 0 0-3-3.05zM26.58 46.1a3.76 3.76 0 1 1 3.76-3.76 3.75 3.75 0 0 1-3.76 3.76zm7.26-7.26a3.76 3.76 0 1 1 3.76-3.75 3.76 3.76 0 0 1-3.76 3.75zm7.26-7.25a3.76 3.76 0 1 1 3.75-3.76 3.76 3.76 0 0 1-3.75 3.76z",
        "fill": "#fdfefe"
      }
    })])])])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "episode-content"
    }, [_c('div', [_c('h3', [_vm._v("Bekijk de aflevering")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Help Berny, speel mee!")])])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b07fd098"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EpisodeModal.vue
// module id = 711
// module chunks = 64